import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        maintenanceMode: false,
        locale: 'en',
        initDone: false,
        currentUser: null,
        language: null,
        loadFileMode: false,
        loadFilePercent: 0,
        loadFilePercentFontSize: 10,
        breadcrumbs: null,
        availableLocales: [],
        festivalPermissions: null,
        festivalData: null,
        addListModal: {
            visible: false,
            blockId: null,
            abParentId: null,
        },
        iframeApplication: {
            visible: false,
            applicationId: null
        }
    },
    mutations: {
        setAddListModal(state, data){
            state.addListModal = {...state.addListModal, ...data}
        },
        setIframeApplication(state, payload) {
            state.iframeApplication.visible = payload.visible
            state.iframeApplication.applicationId = payload.applicationId
        },
        setMaintenanceMode(state, maintenanceMode) {
            state.maintenanceMode = maintenanceMode
        },
        setLanguage(state, language) {
            state.language = language
        },
        setLocale(state, locale) {
            state.locale = locale
        },
        setCurrentUser(state, currentUserData) {
            state.currentUser = currentUserData
        },
        setInitDone(state, initDone) {
            state.initDone = initDone
        },
        setLoadFileMode(state, loadFileMode) {
            state.loadFileMode = loadFileMode
        },
        setBreadcrumbs(state, breadcrumbs) {
            state.breadcrumbs = breadcrumbs
        },
        setAvailableLocales(state, availableLocales) {
            state.availableLocales = availableLocales
        },
        setFestivalPermissions(state, festivalPermissions) {
            state.festivalPermissions = festivalPermissions
        },
        setFestivalData(state, festivalData) {
            state.festivalData = festivalData
        },
        setLoadFilePercent(state, loadFilePercent) {
            state.loadFilePercent = loadFilePercent.text
            state.loadFilePercentFontSize = loadFilePercent.fontSize !== undefined ? loadFilePercent.fontSize : 10
        }
    },
    getters: {
        getAccess: state => (permissionKey) => {
            // const festivalPermissions = state.festivalPermissions ? state.festivalPermissions : [];
            //
            // const allPermissions = state.currentUser ? [...state.currentUser.currentPlan.plan.permissions, ...festivalPermissions]: [...festivalPermissions];
            // return allPermissions.indexOf(permissionKey) !== -1;
            return true
        },
        getIsSocialShow: state => (social) => {
            switch (+state.currentUser.country.id) {
                case 218:
                    return !['instagram', 'facebook'].includes(social)
                default:
                    return true
            }
        },
        getIsArchive: state => () => {
            return state.festivalData?.is_archive
        },
        getIsPremium: state => () => {
            return !!state.festivalData?.isPremium
        },
        getIframeApplication: state => state.iframeApplication,
        getMaintenanceMode: state => {
            return state.maintenanceMode
        },
        getLocale: state => {
            return state.locale
        },
        getLanguage: state => {
            return state.language
        },
        getCurrentUser: state => {
            return state.currentUser
        },
        getInitStatus: state => {
            return state.initDone
        },
        getLoadFileMode: state => {
            return state.loadFileMode
        },
        getLoadFilePercent: state => {
            return state.loadFilePercent
        },
        getLoadFilePercentFontSize: state => {
            return state.loadFilePercentFontSize
        },
        getBreadcrumbs: state => {
            return state.breadcrumbs
        },
        getAvailableLocales: state => {
            return state.availableLocales
        },
        getFestivalPermissions: state => {
            return state.festivalPermissions
        },
        getFestivalData: state => {
            return state.festivalData
        },
        getAddListModal: state => {
            return state.addListModal
        }
    },
    actions: {
        getInitAppData(context, payload) {
            let self = this

            return new Promise((resolve, reject) => {
                axios.get(window.apiUrl + '/api/init/get-init-app-data', {
                    data: null
                })
                    .then(function(response) {
                        context.commit('setCurrentUser', response.data.user)
                        context.commit('setAvailableLocales', response.data.availableLocales)
                        let currentUser = response.data.user

                        resolve(currentUser)
                    })
                    .catch(function(error) {
                        reject(error)
                    })
            })
        }
    }
})
